import { connect } from "react-redux";
import * as actions_misc from "../../../_actions/misc";
import * as actions from "../../../_actions/order";
import Order from "../components/Order";

const mapStateToProps = ({ Order, Misc }) => ({
    loading: Order.fetching.loading,
    fetching_error: Order.fetching.err,
    order: Order.data,
    language: Misc.language.language,
    store: Misc.store.store,
    country: Misc.country.country,
    language_list: Misc.language.language_list,
    store_list: Misc.store.store_list,
    country_list: Misc.country.country_list,
    language_list_loading: Misc.language.fetching.loading,
    store_list_loading: Misc.store.fetching.loading,
    country_list_loading: Misc.country.fetching.loading
});

const mapDispatchToProps = dispatch => ({
    get: id => {
        dispatch(actions.get(id));
    },
    reset: () => {
        dispatch(actions.reset());
    },
    setLanguage: language => {
        dispatch(actions_misc.setLanguage(language));
    },
    setStore: store => {
        dispatch(actions_misc.setStore(store));
    },
    setCountry: country => {
        dispatch(actions_misc.setCountry(country));
    },
    resetLanguage: () => {
        dispatch(actions_misc.resetLanguage());
    },
    resetStore: () => {
        dispatch(actions_misc.resetStore());
    },
    resetCountry: () => {
        dispatch(actions_misc.resetCountry());
    },
    getLanguages() {
        dispatch(actions_misc.getLanguages());
    },
    getStores() {
        dispatch(actions_misc.getStores());
    },
    getCountries() {
        dispatch(actions_misc.getCountries());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Order);
